export default "__VITE_ASSET__DiSzPFzs__"